'use strict';
const angular = require('angular');

export default angular.module('appApp.submissionsectionconfirmation', [])
  .directive('submissionsectionconfirmation', function() {
    return {
      template: require('./submissionsectionconfirmation.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/submissionsectionconfirmation/submissionsectionconfirmation.directive.js